export default function checkErid(value?: string | null): boolean {
  return !!value && /^[a-z0-9]+$/i.test(value)
}
